import "./ProjectPage3.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import SolutionsOverview from "./sections/SolutionsOverview";
import QuoteGrid from "./sections/QuoteGrid";
import Footer from "@/reusable_sections/Footer";
export default function ProjectPage3() {
  return <div>
      <Header />
      <Hero />
      <SolutionsOverview />
      <QuoteGrid />
      <Footer />
    </div>;
}